import { ROUTES } from "@/routes_new";
import { SearchLight } from "@/types/Search";
import { SearchItem } from "./SearchItem";

export function ActiveSearches({
  activeSearches,
  orgUuid,
  pathname,
  onDelete,
}: {
  activeSearches: SearchLight[];
  orgUuid: string;
  pathname: string;
  onDelete: (searchUuid: string) => void;
}) {
  return activeSearches.map((search) => {
    const to = ROUTES.MENTION_DETAIL_ORGID.replace(":orgUuid", orgUuid).replace(
      ":uuid",
      search.uuid
    );

    return (
      <SearchItem
        key={search.uuid}
        to={to}
        search={search}
        orgUuid={orgUuid}
        pathname={pathname}
        onDelete={() => onDelete(search.uuid)}
      />
    );
  });
}
